const SET_SESSION = 'bitbyte-gui/session/SET_SESSION';

const initialState = {
    session: null
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case SET_SESSION:
        return Object.assign({}, state, {
            session: action.session
        });
    default:
        return state;
    }
};

const setSession = function (session) {
    return {
        type: SET_SESSION,
        session: session
    };
};

export {
    reducer as default,
    initialState as sessionInitialState,
    setSession
};
